import { useQuery } from "@tanstack/react-query";
import type { StudyGroupUnreadTotals } from "@/lib/humhub-api/types";
import { studyGroupKeys } from "@/lib/queryKeys/studyGroupKeys";
import { EMPTY_STUDY_GROUP_UNREAD_TOTALS } from "@/lib/studyGroupUnread";

interface UseStudyGroupUnreadBadgeCountsOptions {
  studyGroupId: number;
}

export const useStudyGroupUnreadBadgeCounts = ({
  studyGroupId,
}: UseStudyGroupUnreadBadgeCountsOptions) => {
  return useQuery<StudyGroupUnreadTotals>({
    queryKey: studyGroupKeys.myStudyGroupsUnreadBadge(studyGroupId),
    queryFn: () => EMPTY_STUDY_GROUP_UNREAD_TOTALS,
    enabled: false,
  });
};
